import React from 'react'

export default function Src101Card(props) {
  const { data } = props;

  const img  = data.img.replace('tapwallet.io', 'bitcoinuniverse.io');
  return (
    <div className="flex flex-col border-borderColor border-[1px] border-solid bg-gray-900 p-3 rounded-md min-h-[120px] gap-2 justify-center items-center">
      <img src={img} alt="no image"/>
      <div className="text-primary font-bold text-[20px]">
        {data.tokenid_utf8.toUpperCase()}
      </div>
    </div>
  )
}
